module.exports = __webpack_public_path__ + "static/media/avax-network.2565884a.png";